import React, { useEffect } from 'react';
import { Field, useFormikContext } from 'formik';
import { SttDatePicker } from '@stt-componentes/core';
import { SITUACAO } from '../constantes';
import { SITUACAO_EXAME, DATA_LAUDO_ATE, DATA_INVALIDACAO_ATE } from '../fieldNames';

const DataFinalLaudo = ({ strings }) => {
    const { values, setFieldValue } = useFormikContext();
    const exameValido = values[SITUACAO_EXAME].includes(SITUACAO.VALIDO);
    const exameInvalido = values[SITUACAO_EXAME].includes(SITUACAO.INVALIDO);
    const label = (exameValido && exameInvalido) ? strings.dataFinalParecer : exameInvalido ? strings.dataFinalInvalidacao : strings.dataFinalLaudo;

    const fieldName = (exameValido && exameInvalido) ? DATA_LAUDO_ATE : exameInvalido ? DATA_INVALIDACAO_ATE : DATA_LAUDO_ATE;

    useEffect(() => {
        if (exameValido && exameInvalido) {
            return;
        }

        if (exameInvalido) {
            setFieldValue(DATA_LAUDO_ATE, null);
        }

        if (exameValido) {
            setFieldValue(DATA_INVALIDACAO_ATE, null);
        }
    }, [exameValido, exameInvalido]);

    return (
        <Field name={fieldName}>
            {({
                field: { name, value, },
                form: { setFieldValue, setFieldError, setFieldTouched },
                meta
            }) => {
                let erroAtual = meta.error;
                return (
                    <SttDatePicker
                        label={label}
                        inputProps={{
                            name: name,
                            inputMode: 'numeric'
                        }}
                        disableFuture
                        maxDate={new Date()}
                        error={meta.touched && meta.error ? true : false}
                        onError={error => {
                            if (error && error !== erroAtual) {
                                setFieldError(name, error);
                            }

                        }}
                        value={value}
                        onBlur={() => {
                            setFieldTouched(name, true);
                        }}
                        helperText={meta.touched && meta.error ? meta.error : undefined}
                        onChange={date => {
                            if (!date) {
                                setFieldValue(name, date, true);
                                return;
                            };

                            date.setHours(0);
                            date.setMinutes(0);
                            date.setSeconds(0);
                            setFieldValue(name, date, true);
                        }}
                        onClose={() => setFieldTouched(name, true)}
                    />
                );
            }}
        </Field>
    );
};

export default DataFinalLaudo;